import {configuration} from '@anywhere-expert/core';
import {ArticleType} from '../types';

const {articleBaseUrl} = configuration.helix;

export const getHelixUrl = (articleId: string, articleType: ArticleType) =>
    articleType === 'content' ? `${articleBaseUrl}/content/${articleId}-0` : `${articleBaseUrl}/topic/${articleId}`;
